import { IUser } from '@Data/users/Interfaces';
import { adminEndPoints } from '@Services/data/ApiHandler';
import store from '@Services/redux/Store';
import { AdminActions } from './Reducer';

const Api = {
    getIsUserSuperAdmin: async () => {
        const response = await adminEndPoints.getIsUserSuperAdmin();
        if (response.isSuccess) {
            store.dispatch(
                AdminActions.setIsUserSuperAdmin(response.data.response)
            );
        }
    },
    getAllSuperAdmins: async (callback?: () => void) => {
        const response = await adminEndPoints.getAllSuperAdmins();

        if (response.isSuccess) {
            store.dispatch(
                AdminActions.setSuperAdmins(response.data.super_admin_details)
            );

            if (callback) {
                callback();
            }
        }
    },
    createSuperAdmin: async (content: string, callback?: () => void) => {
        const response = await adminEndPoints.createSuperAdmin(content);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
    deleteSuperAdmin: async (content: string, callback?: () => void) => {
        const response = await adminEndPoints.removeSuperAdmin(content);

        if (response.isSuccess) {
            if (callback) {
                callback();
            }
        }
    },
};

export default Api;
